var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgOffTheTopicIcon = function SvgOffTheTopicIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "6px",
    height: "16px",
    viewBox: "0 0 6 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "request_icon_1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-71.000000, -711.000000)",
    fill: "#20BDA3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.4999869,724.500007 C76.4999869,723.121495 75.3784991,722.000007 73.9999988,722.000007 C72.6214866,722.000007 71.4999988,723.121495 71.4999988,724.500007 C71.4999988,725.878507 72.6214866,726.999995 73.9999988,726.999995 C75.3784991,726.999995 76.4999869,725.878507 76.4999869,724.500007 Z M71.7893658,711.787507 L72.2143831,720.287487 C72.2343415,720.686625 72.563778,721.00001 72.9634353,721.00001 L75.0365504,721.00001 C75.4362077,721.00001 75.7656442,720.686625 75.7856026,720.287487 L76.2106199,711.787507 C76.2320127,711.359102 75.8904913,711.000033 75.4615372,711.000033 L72.5384485,711.000033 C72.1094944,711.000033 71.767973,711.359102 71.7893658,711.787507 Z",
    id: "request_icon_1"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgOffTheTopicIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/off_the_topic_icon.5cd00ab7c5dfa545a8e372e3debdd16b.svg";